import "./assets/identifiedRisks.css";
import { useNavigate } from "react-router-dom";
import { useRiskMatrixQuery } from "./hooks/useRiskMatrixQuery";
import { useRiskMatrixCommond } from "./hooks/useRiskMatrixCommond";
import { ROUTES } from "../../core/routes/routes.js";
import Swal from "sweetalert2";
import { DateUtil } from "../../common/utils/date.util.js";
import { FaFileDownload, FaTrash, FaPencilAlt } from "react-icons/fa";
import Table from "../../common/components/Table";
import IconButton from "../../common/components/IconButton";
import Pagination from "../../common/components/Pagination";

function IdentifiedRisks() {
  const navigate = useNavigate();
  const {
    riskMatrix,
    refresh,
    currentPage,
    loading,
    totalPages,
    onChangePage,
  } = useRiskMatrixQuery();
  const { deleteRiskMatrix } = useRiskMatrixCommond(refresh);

  const handleDeleteRiskMatrix = (id) => {
    Swal.fire({
      title: "¿Estás seguro de eliminar la matriz de riesgos?",
      showDenyButton: true,
      confirmButtonText: `Eliminar`,
      denyButtonText: `Cancelar`,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteRiskMatrix(id);
      }
    });
  };

  const handleViewRiskMatrix = (link) => {
    window.open(link, "_blank");
  };

  const handleEditRiskMatrix = (riskMatrix) => {
    navigate(ROUTES.RISK_MATRIX, { state: { riskMatrix } });
  };

  const columns = [
    {
      header: "Identificados al inicio del año",
      accessor: "initialIdentified",
    },
    { header: "Identificados al final del año", accessor: "finalIdentified" },
    {
      header: "Identificados con valoración alta al inicio del año",
      accessor: "initialHighValuation",
    },
    {
      header: "Identificados con valoración alta al final del año",
      accessor: "finalHighValuation",
    },
    { header: "No conformidades identificadas", accessor: "identifiedIssues" },
    { header: "No conformidades resueltas", accessor: "resolvedIssues" },
    {
      header: "Fecha",
      accessor: "createdAt",
      render: (value) => DateUtil.format(value, "DD/MM/YYYY"),
    },
    {
      header: "Acciones",
      accessor: "actions",
      render: (_, row) => (
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            gap: "0.3rem",
          }}
        >
          <IconButton onClick={() => handleViewRiskMatrix(row.file)}>
            <FaFileDownload />
          </IconButton>
          <IconButton onClick={() => handleDeleteRiskMatrix(row.id)}>
            <FaTrash />
          </IconButton>
          <IconButton onClick={() => handleEditRiskMatrix(row)}>
            <FaPencilAlt />
          </IconButton>
        </div>
      ),
    },
  ];

  return (
    <main className="container-fluid p-4">
      <header className="d-flex justify-content-between align-items-center mb-4 px-3 py-2 border-bottom">
        <h1 className="h2 m-0 fw-bold">Matriz de riesgos identificados</h1>
      </header>

      <section className="shadow w-100 d-flex flex-column">
        <Table columns={columns} data={riskMatrix} loading={loading} />

        <Pagination
          onChangePage={onChangePage}
          page={currentPage}
          totalPages={totalPages}
        />
      </section>
    </main>
  );
}

export default IdentifiedRisks;
